module.exports = __webpack_public_path__ + "static/media/favicon.309f410e.ico";